/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  //***********************************************************************
  // Custom code just for PDP
  //***********************************************************************
  // document.addEventListener('DOMContentLoaded', function () {
  //   console.log('[Init] DOMContentLoaded');

  //   const radios = document.querySelectorAll('input[type="radio"][name^="options["]');
  //   const addButton = document.querySelector('button[name="add"]');
  //   console.log('[Init] Radios encontrados:', radios.length);
  //   console.log('[Init] Botón Add to Cart:', addButton);

  //   // Desmarcar todos los radios al inicio (excepto los del grupo 'color')
  //   radios.forEach(radio => {
  //     const name = radio.name;
  //     const groupName = name.match(/^options\[(.*?)\]/)?.[1];
  //     console.log('[Radio Init] Grupo detectado:', groupName, '| ID:', radio.id);

  //     if (groupName ) {
  //       radio.checked = false;
  //       console.log(`[Radio Init] Desmarcado input de grupo "${groupName}"`);
  //     }
  //   });

  //   // Resetear selección de variante interna (Shopify)
  //   const variantSelect = document.querySelector('form[action^="/cart/add"] select[name="id"]');
  //   if (variantSelect) {
  //     variantSelect.selectedIndex = -1;
  //     variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
  //     console.log('[Shopify Variant] Selector de variantes reseteado');
  //   } else {
  //     console.warn('[Shopify Variant] No se encontró el select[name="id"]');
  //   }

  //   // Detectar qué grupos existen
  //   const nameGroups = {};
  //   radios.forEach(radio => {
  //     const name = radio.name;
  //     if (!(name in nameGroups)) {
  //       nameGroups[name] = false;
  //       console.log('[Group Init] Grupo agregado para validación:', name);
  //     }
  //   });

  //   function validateRadios() {
  //     const missing = [];

  //     for (const name in nameGroups) {
  //       const groupRadios = document.querySelectorAll(`input[name="${name}"]`);
  //       const isSelected = Array.from(groupRadios).some(r => r.checked);
  //       nameGroups[name] = isSelected;

  //       const cleanName = name.match(/^options\[(.*?)\]/)?.[1] || name;

  //       if (!isSelected) {
  //         missing.push(cleanName);
  //         console.log(`[Validation] No seleccionado: ${cleanName}`);
  //       } else {
  //         console.log(`[Validation] Seleccionado: ${cleanName}`);
  //       }
  //     }

  //     const allSelected = Object.values(nameGroups).every(Boolean);
  //     console.log('[Validation] ¿Todas las opciones seleccionadas?', allSelected);

  //     if (addButton) {
  //       addButton.disabled = !allSelected;
  //       addButton.textContent = allSelected
  //         ? 'Add to cart'
  //         : 'Please choose your ' + missing.join(' and ');
  //       console.log('[Button] Estado:', addButton.disabled ? 'Deshabilitado' : 'Habilitado');
  //       console.log('[Button] Texto:', addButton.textContent);
  //     }
  //   }

  //   // Escuchar cambios
  //   radios.forEach(radio => {
  //     radio.addEventListener('change', function () {
  //       console.log('[Radio Change] Cambio en:', radio.name, '| Valor:', radio.value);
  //       setTimeout(validateRadios, 300);
  //     });
  //   });

  //   // Validación inicial
  //   console.log('[Init] Ejecutando validación inicial');
  //   setTimeout(validateRadios, 300);


  //   const radioGroups = document.querySelectorAll('[data-variant-buttons]');

  //   radioGroups.forEach(group => {
  //     group.addEventListener('change', () => {
  //       const legendValue = group.closest('.radio__fieldset, .select__fieldset')?.querySelector('.radio__legend__value');
  //       if (legendValue && legendValue.classList.contains('is-hidden')) {
  //         legendValue.classList.remove('is-hidden');
  //       }
  //     });
  //   });
  // });


  //LAST VERSION//


  document.addEventListener('DOMContentLoaded', function () {
    console.log('[custom.js] DOMContentLoaded');

    if (!window.productJSON) {
      const jsonScript = document.querySelector('script[data-product-json]');
      if (jsonScript) {
        window.productJSON = JSON.parse(jsonScript.textContent);
        console.log('[custom.js] window.productJSON cargado:', window.productJSON);
      } else {
        console.warn('[custom.js] No se encontró el JSON del producto');
      }
    }

    // 👉 Validación inmediata en PDP
    initATCValidation(document);
    // autoSelectColor(document);

    // 👉 Mostrar visualmente el valor de la opción seleccionada
    const radioGroups = document.querySelectorAll('[data-variant-buttons]');
    radioGroups.forEach(group => {
      group.addEventListener('change', () => {
        const legendValue = group.closest('.radio__fieldset, .select__fieldset')?.querySelector('.radio__legend__value');
        if (legendValue && legendValue.classList.contains('is-hidden')) {
          legendValue.classList.remove('is-hidden');
        }
      });
    });

    // 👉 Override de SelloutVariants (usado por el tema)
    class SelloutVariantsOverride extends SelloutVariants {
      getCurrentState() {
        this.selections = [];
        const options = this.container.querySelectorAll(selectors$a.optionInputCurrent);
        const totalOptions = this.productJSON.options.length;

        options.forEach((element) => {
          const elemValue = element.value;
          this.selections.push(elemValue || null);
        });

        while (this.selections.length < totalOptions) {
          this.selections.push(null);
        }
      }

      update() {
        this.getCurrentState();
        if (this.selections.includes(null)) return;
        super.update();
      }
    }

    // 👉 Reemplaza la clase original
    window.SelloutVariants = SelloutVariantsOverride;
  });


  

  // 🔧 Función: Validación de opciones antes de permitir agregar al carrito
  // function initATCValidation(scope = document) {
  //   const radios = scope.querySelectorAll('input[type="radio"][name^="options["]');
  //   const addButton = scope.querySelector('button[name="add"]');
  //   if (!radios.length || !addButton) return;

  //   const nameGroups = {};
  //   radios.forEach(radio => {
  //     const name = radio.name.match(/^options\[[^\]]+\]/)?.[0];
  //     if (name && !(name in nameGroups)) nameGroups[name] = false;
  //   });

  //   // function validateRadios() {
  //   //   const missing = [];

  //   //   for (const name in nameGroups) {
  //   //     const groupRadios = scope.querySelectorAll(`input[name="${name}"]`);
  //   //     const selected = Array.from(groupRadios).some(r => r.checked);
  //   //     nameGroups[name] = selected;

  //   //     const cleanName = name.match(/^options\[(.*?)\]/)?.[1] || name;
  //   //     if (!selected) missing.push(cleanName);
  //   //   }

  //   //   const allSelected = Object.values(nameGroups).every(Boolean);

  //   //   addButton.disabled = !allSelected;
  //   //   addButton.textContent = allSelected
  //   //     ? 'Add to cart'
  //   //     : 'Please choose your ' + missing.join(' and ');

  //   // }

  //   function validateRadios() {
  //     const missing = [];
    
  //     // Verificamos grupo por grupo si hay opciones no seleccionadas
  //     for (const name in nameGroups) {
  //       const groupRadios = scope.querySelectorAll(`input[name="${name}"]`);
  //       const selected = Array.from(groupRadios).some(r => r.checked);
  //       nameGroups[name] = selected;
    
  //       const cleanName = name.match(/^options\[(.*?)\]/)?.[1] || name;
  //       if (!selected) missing.push(cleanName);
  //     }
    
  //     const allSelected = Object.values(nameGroups).every(Boolean);
    
  //     // 👉 Si faltan opciones
  //     if (!allSelected) {
  //       addButton.disabled = true;
  //       addButton.textContent = 'Please choose your ' + missing.join(' and ');
  //       return;
  //     }
    
  //     // 👉 Extraer opciones seleccionadas en orden correcto
  //     const selectedOptions = [];
  //     (window.productJSON?.options || []).forEach(optionName => {
  //       const input = scope.querySelector(`input[name^="options[${optionName}]"]:checked`);

  //       selectedOptions.push(input?.value || null);
  //     });
    
  //     // 👉 Buscar variante exacta
  //     const variant = window.productJSON?.variants.find(v =>
  //       v.options.every((opt, i) => opt === selectedOptions[i])
  //     );
    
  //     // 👉 Mostrar resultado según variante
  //     if (!variant) {
  //       addButton.disabled = true;
  //       addButton.textContent = 'Unavailable';
  //     } else if (!variant.available) {
  //       addButton.disabled = true;
  //       addButton.textContent = 'Sold out';
  //     } else {
  //       addButton.disabled = false;
  //       addButton.textContent = 'Add to cart';
  //     }
  //   }
    

    
    
  

  //   radios.forEach(radio => {
  //     radio.addEventListener('change', validateRadios);
  //   });

  //   validateRadios();
  // }

  function initATCValidation(scope = document, productJSON = window.productJSON) {
    const radios = scope.querySelectorAll('input[type="radio"][name^="options["]');
    const addButton = scope.querySelector('button[name="add"]');
    if (!radios.length || !addButton) return;
  
    // 🔧 Extraer nombres únicos base como 'options[Color]'
    const nameGroups = {};
    radios.forEach(radio => {
      const nameMatch = radio.name.match(/^options\[[^\]]+\]/); // captura 'options[Color]' sin sufijos
      const name = nameMatch?.[0];
      if (name && !(name in nameGroups)) {
        nameGroups[name] = false;
      }
    });
  
    function validateRadios() {
      const missing = [];
  
      for (const name in nameGroups) {
        const groupRadios = scope.querySelectorAll(`input[name^="${name}"]`);
        const selected = Array.from(groupRadios).some(r => r.checked);
        nameGroups[name] = selected;
  
        const cleanName = name.match(/^options\[(.*?)\]/)?.[1] || name;
        if (!selected) missing.push(cleanName);
      }
  
      const allSelected = Object.values(nameGroups).every(Boolean);
  
      if (!allSelected) {
        addButton.disabled = true;
        addButton.textContent = 'Please choose your ' + missing.join(' and ');
        return;
      }
  
      // 🔍 Extraer opciones en el orden definido por Shopify
      const selectedOptions = [];
      (productJSON?.options || []).forEach(optionName => {
        const input = scope.querySelector(`input[name^="options[${optionName}]"]:checked`);
        selectedOptions.push(input?.value || null);
      });
  
      // 🔍 Buscar la variante exacta
      const variant = productJSON?.variants.find(v =>
        v.options.every((opt, i) => opt === selectedOptions[i])
      );
  
      if (!variant) {
        addButton.disabled = true;
        addButton.textContent = 'Unavailable';
      } else if (!variant.available) {
        addButton.disabled = true;
        addButton.textContent = 'Sold out';
      } else {
        addButton.disabled = false;
        addButton.textContent = 'Add to cart';
      }
    }
  
    // ⏯️ Asignar listeners
    radios.forEach(radio => {
      radio.addEventListener('change', validateRadios);
    });
  
    // Ejecutar la primera validación al cargar
    validateRadios();
  }
  

  // 🔧 Función: Autoseleccionar el primer color si ninguno está marcado
  // function autoSelectColor(scope = document) {
  //   const colorRadios = scope.querySelectorAll('input[type="radio"][name^="options[Color]"]');
  //   if (colorRadios.length > 0 && !Array.from(colorRadios).some(r => r.checked)) {
  //     colorRadios[0].checked = true;
  //     colorRadios[0].dispatchEvent(new Event('change'));
  //     console.log('[ATC] Color autoseleccionado');
  //   }
  // }

  window.initATCValidation = initATCValidation;
  // window.autoSelectColor = autoSelectColor;

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
